import { Component } from 'react';
import { connect } from 'react-redux';

import * as actions from '../../../../store/apps/actions';

/**
 * Unknown App Class Component:  Placeholder for apps with undefined component type
 */
class Unknown extends Component {
	/**
	 * local state variable
	 */
	state = {
		allFormsValid: true,
	};

	/**
	 * render()
	 * render the component
	 */
	render() {
		return (
			<div>
				<div className='form-group'>
					<div key={this.props.appData.AppId}>
						<h3>
							Unknown Type: {this.props.appData.Name} (ID:{' '}
							{this.props.appData.id})
						</h3>
					</div>
				</div>
			</div>
		);
	}
}

/**
 * mapDispatchToProps
 * map action-dispatch methods to local props methods
 * @param {*} dispatch
 * dispatch:  represents the dispatch method defined in the actions
 */
const mapDispatchToProps = dispatch => {
	return {
		onCheckValidation: payload => dispatch(actions.checkValidity(payload)),
	};
};

/**
 * Export Unknown component
 */
export default connect(null, mapDispatchToProps)(Unknown);
